import { createHttpInstance } from '~/common/utils/http';

const httpInstance = createHttpInstance('telli', { path: '/tudo' });

export default httpInstance;
